import { Directive } from "@angular/core";

const AURORA_BUTTONS = ':not(aurora-button):not(aurora-icon-button):not(aurora-link-button)';

@Directive({
    selector: '[click]:not([disabled]):not(:disabled):not(.workflow_workspace--task)' + AURORA_BUTTONS,
    host: {
        'style': 'cursor: pointer'
    },
    standalone: false
})
export class ClickCursorDirective {}